import { useEffect, useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";

const STEPS = ["Market research", "Technical assessment", "Cost breakdown", "Financial projections", "Legal & regulatory scan", "Risk assessment", "Executive summary"];

export const GeneratingLoader = ({ name, steps = STEPS, note = "This usually takes 1–2 minutes. You can leave this page — the study will be in My Studies." }) => {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setStep((s) => Math.min(s + 1, steps.length - 1)), 9000);
    return () => clearInterval(t);
  }, [steps.length]);
  return (
    <div className="max-w-xl mx-auto py-24 px-4 fade-up" data-testid="generating-loader">
      <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-semibold mb-3">AI analyst at work</p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mb-2">Building “{name}”</h1>
      <p className="text-slate-400 mb-10">{note}</p>
      <ol className="space-y-4">
        {steps.map((s, i) => (
          <li key={s} className={`flex items-center gap-3 transition-opacity ${i > step ? "opacity-30" : ""}`}>
            {i < step ? <CheckCircle2 className="h-5 w-5 text-emerald-400" /> : i === step ? <Loader2 className="h-5 w-5 text-emerald-400 animate-spin" /> : <span className="h-5 w-5 rounded-full border border-slate-700" />}
            <span className={i === step ? "text-slate-100" : "text-slate-400"}>{s}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};
